/* Indigenous Box storefront behavior. Ported from the October 15, 2026 prototype
   (storefront.js, boutique.js, hero-motion.js, commerce.js, qc-enhancements.js)
   with the prototype's sessionStorage cart replaced by the Shopify cart API. */
(() => {
  const sized = src => src ? src + (src.includes('?') ? '&' : '?') + 'width=900' : '';
  const money = cents => '$' + (cents / 100).toFixed(2) + ' CAD';
  const node = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');

  /* Header: hide on down-scroll, return on up-scroll, never while a header control has focus */
  let prev = scrollY;
  addEventListener('scroll', () => {
    const h = document.querySelector('.header');
    if (h) h.classList.toggle('header-hidden', scrollY > 200 && scrollY > prev && !h.contains(document.activeElement));
    prev = scrollY;
  }, { passive: true });

  /* Hero drift */
  (() => {
    const hero = document.querySelector('.hero-editorial'), media = hero && hero.querySelector('.hero-media');
    if (!hero || !media) return;
    const mobile = matchMedia('(max-width:620px)');
    let pending = false;
    function paint() {
      pending = false;
      if (reduced.matches || mobile.matches) { media.style.removeProperty('--hero-drift'); return; }
      const rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height)));
      media.style.setProperty('--hero-drift', (progress * 30).toFixed(1) + 'px');
    }
    function schedule() { if (!pending) { pending = true; requestAnimationFrame(paint); } }
    addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', schedule);
    reduced.addEventListener('change', schedule); mobile.addEventListener('change', schedule); paint();
  })();

  /* Press strip scroll-responsive shift */
  (() => {
    const proof = document.querySelector('[data-proof-scroll]');
    if (!proof) return;
    let scheduled = false;
    function motion() {
      scheduled = false;
      const rect = proof.getBoundingClientRect();
      const travel = reduced.matches ? 0 : Math.max(-60, Math.min(60, (innerHeight / 2 - rect.top - rect.height / 2) * .12));
      proof.querySelectorAll('.proof-row').forEach(row => row.style.setProperty('--proof-shift', (travel * Number(row.dataset.direction)) + 'px'));
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(motion); } }
    addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', schedule); reduced.addEventListener('change', schedule); motion();
  })();

  /* Reveal on scroll */
  if (!reduced.matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); } }), { threshold: .08 });
    document.querySelectorAll('.editorial-copy,.editorial-images,.inside-grid,.founder-grid,.section-head').forEach(el => { el.classList.add('reveal-ready'); observer.observe(el); });
  }

  /* Gift finder */
  (() => {
    const form = document.querySelector('[data-gift-finder]'), dataEl = document.querySelector('[data-gift-finder-data]');
    if (!form || !dataEl) return;
    let data; try { data = JSON.parse(dataEl.textContent); } catch { return; }
    form.addEventListener('submit', event => {
      event.preventDefault();
      const budget = document.getElementById('finder-budget').value, style = document.getElementById('finder-style').value;
      const r = style === 'build' ? data.build : (data[budget] || data['200'] || data['100'] || data['50']);
      const target = document.getElementById('finder-result');
      target.replaceChildren();
      if (!r) { target.append(node('p', 'small', 'Browse all gifts to find a match.')); target.className = 'finder-result'; return; }
      const im = new Image(); im.src = r.image; im.alt = r.title;
      const body = node('div'), title = node('h3', '', r.title), text = node('p', '', r.text), link = node('a', 'btn primary', r.cta);
      link.href = r.url; body.append(title, text, link);
      if (document.getElementById('finder-recipient').value === 'team' && data.team_note) body.append(node('p', 'small', data.team_note));
      target.append(im, body); target.className = 'finder-result';
    });
  })();

  /* Inside the box: maker selectors */
  (() => {
    const controls = document.getElementById('maker-controls'), detail = document.getElementById('maker-detail'), dataEl = document.querySelector('[data-makers]');
    if (!controls || !detail || !dataEl) return;
    let makers; try { makers = JSON.parse(dataEl.textContent); } catch { return; }
    if (!makers.length) return;
    function show(i) {
      controls.querySelectorAll('button').forEach((b, n) => b.setAttribute('aria-pressed', String(i === n)));
      detail.replaceChildren();
      const label = node('div', 'eyebrow', 'From ' + makers[i].maker), h = node('h3', '', makers[i].name), p = node('p', '', makers[i].text);
      detail.append(label, h, p);
    }
    makers.forEach((m, i) => { const b = node('button', '', m.name); b.type = 'button'; b.onclick = () => show(i); controls.append(b); });
    show(0);
  })();

  /* Gallery cards: photo buttons and hover swap */
  function bindGallery() { document.querySelectorAll('.product-gallery-card:not([data-gallery-bound])').forEach(wrapper => {
    wrapper.dataset.galleryBound = 'true';
    const card = wrapper.querySelector('.product-card'), photo = card && card.querySelector('img'), buttons = wrapper.querySelectorAll('[data-card-photo]');
    if (!card || !photo || !buttons.length) return;
    const original = photo.getAttribute('src');
    function set(src) { photo.src = src; photo.removeAttribute('srcset'); }
    buttons.forEach(button => button.onclick = () => { set(button.dataset.cardPhoto); buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button))); });
    if (matchMedia('(hover:hover)').matches && buttons[1]) {
      card.addEventListener('mouseenter', () => set(buttons[1].dataset.cardPhoto));
      card.addEventListener('mouseleave', () => { const pressed = Array.from(buttons).find(b => b.getAttribute('aria-pressed') === 'true'); set(pressed ? pressed.dataset.cardPhoto : original); });
    }
  }); }
  bindGallery();

  /* Gift collection filters: price from live card prices, product mix from mix: tags (DEV-026) */
  (() => {
    const status = document.getElementById('filter-status'), empty = document.getElementById('filter-empty');
    if (!status) return;
    let priceFilter = 'all', descriptor = 'all';
    const matches = (price, tags) => (priceFilter === 'all' || priceFilter === 'under50' && price < 50 || priceFilter === '50to100' && price >= 50 && price <= 100 || priceFilter === '100plus' && price > 100) && (descriptor === 'all' || tags.split('|').includes(descriptor));
    function apply() {
      let count = 0;
      document.querySelectorAll('.product-card[data-price]').forEach(card => {
        const hide = !matches(Number(card.dataset.price), card.dataset.tags || '');
        card.hidden = hide;
        const wrapper = card.closest('.product-gallery-card,.commerce-card');
        if (wrapper) wrapper.hidden = hide;
        if (!hide) count++;
      });
      const all = priceFilter === 'all' && descriptor === 'all';
      status.textContent = (all ? 'Showing all ' : 'Showing ') + count + ' ' + (count === 1 ? 'gift' : 'gifts');
      if (empty) empty.hidden = count > 0;
    }
    document.querySelectorAll('[data-filter]').forEach(btn => btn.onclick = () => { priceFilter = btn.dataset.filter; document.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === btn))); apply(); });
    document.querySelectorAll('[data-descriptor]').forEach(btn => btn.onclick = () => { descriptor = btn.dataset.descriptor; document.querySelectorAll('[data-descriptor]').forEach(b => b.setAttribute('aria-pressed', String(b === btn))); apply(); });
    const clear = document.getElementById('clear-gift-filters');
    if (clear) clear.addEventListener('click', () => { priceFilter = 'all'; descriptor = 'all'; document.querySelectorAll('[data-filter],[data-descriptor]').forEach(b => b.setAttribute('aria-pressed', String((b.dataset.filter || b.dataset.descriptor) === 'all'))); apply(); });
  })();

  /* Search as you type: Shopify search rendered through the section rendering API */
  (() => {
    const wrap = document.getElementById('ib-search'), input = document.getElementById('catalog-search'), form = document.getElementById('catalog-search-form');
    if (!wrap || !input) return;
    const count = document.getElementById('search-count'), results = document.getElementById('search-results');
    let timer, controller;
    async function refresh() {
      const q = input.value.trim();
      if (controller) controller.abort();
      controller = new AbortController();
      const url = wrap.dataset.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=' + encodeURIComponent(wrap.dataset.sectionId);
      try {
        const res = await fetch(url, { signal: controller.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCount = doc.getElementById('search-count'), newResults = doc.getElementById('search-results');
        if (newCount && count) count.textContent = newCount.textContent;
        if (newResults && results) results.replaceChildren(...Array.from(newResults.childNodes));
        const nav = wrap.querySelector('.pagination'), newNav = doc.querySelector('.pagination');
        if (nav) nav.remove();
        if (newNav) wrap.append(newNav);
        history.replaceState(null, '', wrap.dataset.searchUrl + (q ? '?q=' + encodeURIComponent(q) + '&type=product' : ''));
        bindGallery(); bind();
      } catch (e) { if (e.name !== 'AbortError' && count) count.textContent = 'Search is unavailable right now. Browse the product categories instead.'; }
    }
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(refresh, 250); });
    if (form) form.addEventListener('submit', e => { e.preventDefault(); clearTimeout(timer); refresh(); });
  })();

  /* Commerce: Shopify cart */
  const productCache = {};
  async function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('product');
    const p = await res.json(); productCache[handle] = p; return p;
  }
  async function cartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const c = await res.json();
      document.querySelectorAll('[data-cart-link]').forEach(a => a.textContent = 'Cart' + (c.item_count ? ' (' + c.item_count + ')' : ''));
      return c;
    } catch { return null; }
  }
  window.IB_REFRESH_CART_COUNT = cartCount;

  const status = node('aside', 'cart-confirmation'); status.hidden = true; status.setAttribute('aria-label', 'Added to cart');
  const announcement = node('div', 'sr-only'); announcement.setAttribute('role', 'status'); announcement.setAttribute('aria-live', 'polite');
  document.body.append(status, announcement);

  let opener;
  const dialog = node('dialog', 'quick-view-dialog'); dialog.setAttribute('aria-labelledby', 'quick-view-title'); document.body.append(dialog);
  function closeDialog() { dialog.close(); if (opener) opener.focus(); }
  dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(); } });
  dialog.addEventListener('close', () => { if (opener) opener.focus(); });

  async function add(variantId, qty, name, trigger, sellingPlan, properties) {
    const button = trigger; const label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const item = { id: variantId, quantity: qty };
      if (sellingPlan) item.selling_plan = sellingPlan;
      if (properties && Object.keys(properties).length) item.properties = properties;
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      if (dialog.open) closeDialog();
      await cartCount();
      document.dispatchEvent(new CustomEvent('ib:cart-updated'));
      status.replaceChildren(node('strong', '', 'Added to your cart'), node('p', '', name + ' · ' + qty));
      const view = node('a', 'btn primary', 'View cart'); view.href = '/cart';
      const stay = node('button', 'btn secondary', 'Keep browsing'); stay.type = 'button'; stay.onclick = () => { status.hidden = true; };
      status.append(view, stay); status.hidden = false;
      announcement.textContent = qty + ' ' + name + ' added to your cart.';
    } catch (err) {
      announcement.textContent = err.message;
      status.replaceChildren(node('strong', '', 'Not added'), node('p', '', err.message));
      const stay = node('button', 'btn secondary', 'Close'); stay.type = 'button'; stay.onclick = () => { status.hidden = true; };
      status.append(stay); status.hidden = false;
    } finally {
      if (button) { button.disabled = false; button.textContent = label; }
    }
  }

  function pricing(v) {
    const row = node('div', 'commerce-price');
    if (v.compare_at_price > v.price) row.append(node('del', '', money(v.compare_at_price)));
    row.append(node('strong', '', money(v.price)));
    if (v.compare_at_price > v.price) row.append(node('span', 'commerce-savings', 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'));
    return row;
  }

  function purchase(p, image) {
    const box = node('div', 'purchase-controls');
    let selected = p.variants.find(v => v.available) || p.variants[0];
    const price = node('div'); box.append(price);
    const label = node('label', '', 'Choose your option'), select = node('select');
    select.setAttribute('aria-label', 'Choose an option for ' + p.title);
    p.variants.forEach(v => { const o = node('option', '', v.title === 'Default Title' ? p.title : v.title); o.value = String(v.id); o.disabled = !v.available; if (!v.available) o.textContent += ' · Sold out'; select.append(o); });
    select.value = String(selected.id); label.append(select);
    if (p.variants.length > 1) box.append(label);
    const qtyLabel = node('label', '', 'Quantity'), qty = node('input');
    qty.type = 'number'; qty.min = '1'; qty.max = '100'; qty.step = '1'; qty.value = '1'; qty.setAttribute('aria-label', 'Quantity for ' + p.title);
    qtyLabel.append(qty); box.append(qtyLabel);
    const button = node('button', 'btn primary'); button.type = 'button';
    function update() { price.replaceChildren(pricing(selected)); button.disabled = !selected.available; button.textContent = selected.available ? 'Add to cart · ' + money(selected.price) : 'Sold out'; }
    select.onchange = () => {
      selected = p.variants.find(v => String(v.id) === select.value);
      if (image && selected.featured_image) { image.src = sized(selected.featured_image.src); image.alt = p.title + ' · ' + selected.title; }
      update();
    };
    button.onclick = () => add(selected.id, Math.max(1, Math.min(100, Math.floor(Number(qty.value) || 1))), p.title, button);
    box.append(button);
    box.append(node('p', 'small', 'Prices in CAD. Eligible orders $150+ receive free standard shipping in Canada. Below the threshold, shipping is carrier-calculated at checkout. Applicable taxes are shown before payment.'));
    update(); return box;
  }

  async function quick(handle, trigger) {
    let p; try { p = await getProduct(handle); } catch { location.href = '/products/' + handle; return; }
    opener = trigger; dialog.replaceChildren();
    const closeButton = node('button', 'quick-view-close', 'Close ×'); closeButton.type = 'button'; closeButton.setAttribute('aria-label', 'Close quick view'); closeButton.onclick = closeDialog; dialog.append(closeButton);
    const grid = node('div', 'quick-view-grid'), media = node('div'), image = new Image();
    const images = (p.images || []).map(sized);
    image.src = images[0] || ''; image.alt = p.title; image.className = 'quick-view-photo'; media.append(image);
    if (images.length > 1) {
      const thumbs = node('div', 'quick-view-thumbs');
      images.slice(0, 6).forEach((src, i) => { const b = node('button', '', String(i + 1)); b.type = 'button'; b.setAttribute('aria-label', 'View photo ' + (i + 1)); b.setAttribute('aria-pressed', String(i === 0)); b.onclick = () => { image.src = src; thumbs.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', String(x === b))); }; thumbs.append(b); });
      media.append(thumbs);
    }
    const content = node('div');
    content.append(node('p', 'eyebrow', 'Quick view · ' + p.vendor));
    const title = node('h2', '', p.title); title.id = 'quick-view-title'; content.append(title);
    const tmp = document.createElement('div'); tmp.innerHTML = p.description || ''; const text = (tmp.textContent || '').trim();
    content.append(node('p', '', text.slice(0, 280) + (text.length > 280 ? '…' : '')), purchase(p, image));
    const full = node('a', 'text-link', 'See all product details →'); full.href = '/products/' + p.handle; content.append(full);
    grid.append(media, content); dialog.append(grid); dialog.showModal(); closeButton.focus();
  }

  function bind() {
    document.querySelectorAll('[data-quick-view]:not([data-bound])').forEach(b => { b.dataset.bound = 'true'; b.onclick = () => quick(b.dataset.quickView, b); });
    document.querySelectorAll('[data-card-add]:not([data-bound])').forEach(b => {
      b.dataset.bound = 'true';
      b.onclick = () => {
        if (Number(b.dataset.variantCount) > 1 || !b.dataset.variantId) quick(b.dataset.cardAdd, b);
        else add(Number(b.dataset.variantId), 1, b.dataset.productTitle || '', b);
      };
    });
  }
  bind(); cartCount();
  document.addEventListener('shopify:section:load', bindGallery);
  window.IB_ADD_PRODUCT = (handle, trigger) => quick(handle, trigger);
  window.IB_QUICK_VIEW = quick;
  window.IB_CART_ADD = add;
  window.IB_MONEY = money;
  document.addEventListener('shopify:section:load', bind);
})();

/* Product page: variant binding, gallery, add to cart (DEV-030, DEV-031) */
(function () {
  function init() {
    const form = document.querySelector('[data-product-form]:not([data-pdp-bound])');
    if (!form) return;
    form.dataset.pdpBound = 'true';
    const select = form.querySelector('select[name="id"]');
    const hidden = form.querySelector('input[name="id"]');
    const qty = form.querySelector('input[name="quantity"]');
    const button = form.querySelector('#add-product');
    const photo = document.getElementById('product-photo');
    const thumbs = document.getElementById('product-thumbs');
    const priceLine = document.getElementById('product-price');
    const name = (document.getElementById('product-name') || {}).textContent || '';
    const money = window.IB_MONEY || (c => '$' + (c / 100).toFixed(2));
    function setPhoto(src, mediaId) {
      if (!photo || !src) return;
      photo.src = src; photo.removeAttribute('srcset');
      if (thumbs) thumbs.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mediaId === String(mediaId) || b.dataset.thumb === src)));
    }
    if (thumbs) thumbs.querySelectorAll('button').forEach(b => { b.onclick = () => setPhoto(b.dataset.thumb, b.dataset.mediaId); });
    function current() {
      if (select) return select.options[select.selectedIndex];
      return hidden;
    }
    function update() {
      const o = current(); if (!o) return;
      const available = o.dataset.available === 'true';
      if (select && priceLine) {
        const price = Number(o.dataset.price), compare = Number(o.dataset.compare);
        priceLine.replaceChildren();
        if (compare > price) { const d = document.createElement('del'); d.textContent = money(compare); priceLine.append(d, ' '); }
        const sp = document.createElement('span'); sp.className = 'price'; sp.textContent = money(price); priceLine.append(sp);
        if (compare > price) { const sv = document.createElement('span'); sv.className = 'savings'; sv.textContent = 'Save ' + Math.round((compare - price) / compare * 100) + '%'; priceLine.append(' ', sv); }
        if (o.dataset.image) setPhoto(o.dataset.image, o.dataset.mediaId);
        const url = new URL(location.href); url.searchParams.set('variant', o.value); history.replaceState(null, '', url);
      }
      button.disabled = !available;
      button.textContent = available ? button.dataset.label + ' · ' + money(Number(o.dataset.price || button.dataset.price || 0)).replace(' CAD', '') : (button.dataset.soldOut || 'Currently sold out');
    }
    if (select) { select.addEventListener('change', update); }
    if (hidden) { button.dataset.price = button.dataset.price || ''; }
    form.addEventListener('submit', async e => {
      if (!window.IB_CART_ADD) return;
      e.preventDefault();
      const o = current(); const id = Number(o.value);
      const q = Math.max(1, Math.min(100, Math.floor(Number(qty.value) || 1)));
      const plan = form.querySelector('[name="selling_plan"]');
      const props = {};
      form.querySelectorAll('[name^="properties["]').forEach(i => { if (i.value) props[i.name.slice(11, -1)] = i.value; });
      await window.IB_CART_ADD(id, q, name, button, plan && plan.value ? Number(plan.value) : null, props);
    });
    if (select) update();
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();

  /* Hide an app block section that rendered nothing visible (for example a review widget with no reviews yet) */
  function trimEmptyApps() {
    document.querySelectorAll('section.apps').forEach(sec => {
      const wrap = sec.querySelector('.wrap');
      const text = (wrap.innerText || '').trim();
      const media = [...wrap.querySelectorAll('img,iframe,svg,canvas,video')].some(e => e.offsetHeight > 4);
      sec.hidden = !text && !media;
      sec.classList.toggle('apps-empty', sec.hidden);
    });
  }
  window.addEventListener('load', () => { trimEmptyApps(); setTimeout(trimEmptyApps, 2500); });
